<template>
  <div class="tp-app">
    <el-container v-if="authStore.isLoggedIn" class="tp-app__layout">
      <el-aside width="220px" class="tp-app__sidebar">
        <div class="tp-app__logo">任务管理系统</div>
        <el-menu
          :default-active="$route.path"
          router
          class="tp-app__menu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
          <el-menu-item index="/task/create">
            <el-icon><Plus /></el-icon>
            <span>任务创建</span>
          </el-menu-item>
          <el-menu-item index="/task/todo">
            <el-icon><List /></el-icon>
            <span>待办任务</span>
          </el-menu-item>
          <el-sub-menu index="/task/today">
            <template #title>
              <el-icon><Calendar /></el-icon>
              <span>今日任务</span>
            </template>
            <el-menu-item index="/task/today/deadline">今日截止</el-menu-item>
            <el-menu-item index="/task/today/plan">今日计划</el-menu-item>
          </el-sub-menu>
          <el-menu-item index="/task/archive">
            <el-icon><Finished /></el-icon>
            <span>已完成归档</span>
          </el-menu-item>
          <el-menu-item index="/task/statistics">
            <el-icon><DataLine /></el-icon>
            <span>任务统计</span>
          </el-menu-item>
          <el-menu-item index="/task/search">
            <el-icon><Search /></el-icon>
            <span>搜索与筛选</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header class="tp-app__header" height="56px">
          <div class="tp-app__header-right">
            <span class="tp-app__username">{{ authStore.username }}</span>
            <el-button type="danger" link @click="handleLogout">退出登录</el-button>
          </div>
        </el-header>
        <el-main class="tp-app__main">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </el-main>
      </el-container>
    </el-container>

    <router-view v-else />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Plus, List, Calendar, Finished, DataLine, Search } from '@element-plus/icons-vue'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

function handleLogout() {
  authStore.logout()
  ElMessage.success('已退出登录')
  router.push('/login')
}
</script>

<style scoped>
.tp-app {
  height: 100vh;
}
.tp-app__layout {
  height: 100%;
}
.tp-app__sidebar {
  background-color: #304156;
}
.tp-app__logo {
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background-color: #2b3649;
  border-bottom: 1px solid #1f2d3d;
}
.tp-app__menu {
  border-right: none;
}
.tp-app__header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  z-index: 1;
}
.tp-app__header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.tp-app__username {
  font-size: 14px;
  color: #606266;
}
.tp-app__main {
  background-color: #f0f2f5;
  padding: 0;
  overflow-y: auto;
}
</style>
